const EXT_PAY_SYS_API_BASE_URL = '/service/ext_pay_sys';

export const apiRoutes = {
  editIban: () => `${EXT_PAY_SYS_API_BASE_URL}/v1/iban/edit`
};
